import { connect } from 'react-redux';

import DYCarouselRecs from 'components/DYCarouselRecs';
import { CAMPAIGN_NAMES, PERSONALIZATION_STATUS } from 'constants/personalizations';
import DYRecommendationsModel from 'models/DYRecommendations';
import * as actions from 'state/actions';
import PersonalizationsSelector from 'state/selectors/personalizations';

const mapStateToProps = state => {
  let recommendationsData = {};
  const campaignData = PersonalizationsSelector.getCampaignByName(
    state,
    CAMPAIGN_NAMES.COLLECTION_RECS
  );

  if (campaignData?.status === PERSONALIZATION_STATUS.SUCCESS) {
    recommendationsData = new DYRecommendationsModel(campaignData);
  }

  return {
    heading: recommendationsData.title,
    products: recommendationsData.uniqueProductsByHandle,
    showColorway: recommendationsData.showColorway,
    showPrice: recommendationsData.showPrice,
  };
};

const mapDispatchToProps = dispatch => ({
  trackClick: ({ slotId, productName }) =>
    dispatch(
      actions.trackDYRecsClick({
        eventCategory: 'collections',
        eventAction: 'recs_abovefooter_click',
        eventLabel: productName,
        slotId,
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(DYCarouselRecs);
